import { render, staticRenderFns } from "./SlideTitleSection.vue?vue&type=template&id=05dacb10"
import script from "./SlideTitleSection.vue?vue&type=script&lang=js"
export * from "./SlideTitleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05dacb10')) {
      api.createRecord('05dacb10', component.options)
    } else {
      api.reload('05dacb10', component.options)
    }
    module.hot.accept("./SlideTitleSection.vue?vue&type=template&id=05dacb10", function () {
      api.rerender('05dacb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/SlideTitleSection.vue"
export default component.exports